module.exports = __webpack_public_path__ + "static/media/heron-lab.ea4776bf.jpg";